import _inject from "@stylexjs/stylex/lib/stylex-inject";
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
import React from 'react';
import * as stylex from '@stylexjs/stylex';
import StackableItem from "noood/comp/data/StackableItem";
import { color } from "noood/util/ui/color";
import Icon from "noood/comp/ui/feather-icon/Icon";
import { string_util } from "noood/util/string/StringUtil";
export default function ObjectViewer2(props) {
  var _Object$keys, _props$base_icon_colo;
  var __fuzzyMatch = function __fuzzyMatch(property) {
    if (property.match(/\s?id|quantity/i)) return "hash";
    if (property.match(/(username|name)/)) return "tag";
    if (property.match(/(description|desc)/)) return "menu";
    if (property.match(/(address|location)/)) return "map-pin";
    if (property.match(/(_dt|_date)/)) return "calendar";
    if (property.match(/(status)/)) return "loader";
    if (property.match(/(img|image|picture)/)) return "image";
    if (property.match(/(_by)/)) return "user";
    if (property.match(/(price|amount)/)) return "money-bill";
    if (property.match(/^(del)$/)) return "trash-2";
    if (property.match(/^(hierarchy)$/)) return "arrow-up";
  };
  var keys = (_Object$keys = Object.keys(props.obj)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.filter(function (k) {
    if (props.properties) {
      var _props$properties;
      return ((_props$properties = props.properties) === null || _props$properties === void 0 ? void 0 : _props$properties.indexOf(k)) > -1;
    } else return true;
  });
  var finalBaseColor = (_props$base_icon_colo = props.base_icon_color) !== null && _props$base_icon_colo !== void 0 ? _props$base_icon_colo : color.extractCSSValue("--accent");
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      width: "100%"
    }
  }, props.obj && /*#__PURE__*/React.createElement(React.Fragment, null, keys === null || keys === void 0 ? void 0 : keys.map(function (prop, idx) {
    var _props$hue_area2, _ref2, _props$fields$prop$ic2, _props$fields3, _props$fields$prop$la2, _props$fields4;
    if (props.compact) {
      var _ref, _props$fields$prop$ic, _props$fields, _props$hue_area, _props$fields$prop$la, _props$fields2;
      return /*#__PURE__*/React.createElement("div", _extends({}, {
        className: "ObjectViewer2__ui.item ev14odnwx ev1y7ric0 evahuq5n ev6p6252 evc2wv43 evhlenjp evmx0gy6"
      }, {
        key: "viewer-item-".concat(idx)
      }), /*#__PURE__*/React.createElement("div", {
        className: "ObjectViewer2__ui.item_value ev78zum5 ev1j9xkj6"
      }, /*#__PURE__*/React.createElement(Icon, {
        icon: (_ref = (_props$fields$prop$ic = (_props$fields = props.fields) === null || _props$fields === void 0 || (_props$fields = _props$fields[prop]) === null || _props$fields === void 0 ? void 0 : _props$fields.icon) !== null && _props$fields$prop$ic !== void 0 ? _props$fields$prop$ic : __fuzzyMatch(prop)) !== null && _ref !== void 0 ? _ref : 'maximize',
        color: color.adjustHue(finalBaseColor, ((_props$hue_area = props.hue_area) !== null && _props$hue_area !== void 0 ? _props$hue_area : 20) / keys.length * idx)
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          flexBasis: "80px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          color: "var(--shade-40)"
        }
      }, (_props$fields$prop$la = (_props$fields2 = props.fields) === null || _props$fields2 === void 0 || (_props$fields2 = _props$fields2[prop]) === null || _props$fields2 === void 0 ? void 0 : _props$fields2.label) !== null && _props$fields$prop$la !== void 0 ? _props$fields$prop$la : string_util.uc_words(prop, '_')), /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 1
        }
      }, _typeof(props.obj[prop]) === 'object' && props.obj[prop] ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ObjectViewer2, {
        compact: true,
        obj: props.obj[prop],
        base_icon_color: finalBaseColor
      })) : /*#__PURE__*/React.createElement(React.Fragment, null, props.obj[prop]))));
    }
    return /*#__PURE__*/React.createElement(StackableItem, {
      first: idx === 0,
      key: "obj-info-".concat(idx),
      last: idx === keys.length - 1,
      iconColor: color.adjustHue(finalBaseColor, ((_props$hue_area2 = props.hue_area) !== null && _props$hue_area2 !== void 0 ? _props$hue_area2 : 20) / keys.length * idx),
      icon: (_ref2 = (_props$fields$prop$ic2 = (_props$fields3 = props.fields) === null || _props$fields3 === void 0 || (_props$fields3 = _props$fields3[prop]) === null || _props$fields3 === void 0 ? void 0 : _props$fields3.icon) !== null && _props$fields$prop$ic2 !== void 0 ? _props$fields$prop$ic2 : __fuzzyMatch(prop)) !== null && _ref2 !== void 0 ? _ref2 : 'maximize',
      label: (_props$fields$prop$la2 = (_props$fields4 = props.fields) === null || _props$fields4 === void 0 || (_props$fields4 = _props$fields4[prop]) === null || _props$fields4 === void 0 ? void 0 : _props$fields4.label) !== null && _props$fields$prop$la2 !== void 0 ? _props$fields$prop$la2 : prop
    }, _typeof(props.obj[prop]) === "object" && props.obj[prop] !== null ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ObjectViewer2, {
      obj: props.obj[prop],
      base_icon_color: "#cb5959"
    })) : /*#__PURE__*/React.createElement(React.Fragment, null, props.obj[prop]));
  }))));
}
ObjectViewer2.propTypes = {
  // proptypes
};

// @ts-ignore
_inject(".ev14odnwx{padding:5px}", 1000);
_inject(".ev1y7ric0{background-color:var(--shade-05)}", 3000);
_inject(".evahuq5n:nth-of-type(odd){background-color:var(--shade-10)}", 3062);
_inject(".ev6p6252:nth-of-type(1){border-top-left-radius:var(--roundness)}", 4062);
_inject(".evc2wv43:nth-of-type(1){border-top-right-radius:var(--roundness)}", 4062);
_inject(".evhlenjp:nth-last-of-type(1){border-bottom-left-radius:var(--roundness)}", 4063);
_inject(".evmx0gy6:nth-last-of-type(1){border-bottom-right-radius:var(--roundness)}", 4063);
_inject(".ev78zum5{display:flex}", 3000);
_inject(".ev1j9xkj6{gap:7px}", 2000);